module.exports = __webpack_public_path__ + "img/ar18.c2b3d960.jpg";